import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { getLatestReleaseTitle } from '../../../release-notes/release-notes.data';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  standalone: false
})
export class LandingComponent {
  /** Latest published release, announced in the hero. */
  readonly latestReleaseTitle: string = getLatestReleaseTitle();

  constructor(private router: Router) {}

  navigateToLogin(): void {
    this.router.navigate(['/auth/login']);
  }

  navigateToSignup(): void {
    this.router.navigate(['/auth/signup']);
  }
}
